// https://www.npmjs.com/package/@ant-design/colors
import {
  red,
  volcano,
  gold,
  lime,
  green,
  blue,
  geekblue,
  purple,
  magenta,
  grey,
  orange,
  generate,
} from "@ant-design/colors";

import voicefulColors from "./voiceful/colors";

export const colors = voicefulColors as {
  red: string;
  violet: string;
  yellow: string;
  green: string;
  dark1: string;
  dark2: string;
  dark3: string;
  light1: string;
  light2: string;
  light3: string;
  light4: string;
  success: string;
  error: string;
  warning: string;
  info: string;
};

// Generate color palettes by a given color
export const palettes = {
  red: generate(voicefulColors.red),
  violet: generate(voicefulColors.violet),
  yellow: generate(voicefulColors.yellow),
  green: generate(voicefulColors.green),
};

export const palettesArray = Object.values(palettes);

export const voiceColors = [
  ...palettesArray,
  green,
  purple,
  magenta,
  blue,
  red,
  geekblue,
  orange,
  lime,
  volcano,
  gold,
  grey,
];
